import type { OCRScopeWorkStatus } from './ocr-scope-work-status'

/**
 * Formats the status of a scope work.
 */
export function formatOCRScopeWorkStatus(status: OCRScopeWorkStatus) {
  switch (status) {
    case 'ScopingInProgress':
      return 'Scoping in progress'
    case 'ErrorOccurred':
      return 'Error occurred'
    case 'ReviewRequired':
      return 'Review required'
    case 'ReviewSuggested':
      return 'Review suggested'
    case 'ReadyToSubmit':
      return 'Ready to submit'
    case 'Completed':
      return 'Completed'
    case 'Unknown':
      return 'Unknown'
  }
}
